import { IconButton, TextField, TextFieldProps } from '@material-ui/core'
import { Visibility, VisibilityOff } from '@material-ui/icons'
import cls from 'classnames'
import { forwardRef, ForwardRefRenderFunction, useState } from 'react'

import { useStyles } from './styles'

type InputTextProps = TextFieldProps & {
  success?: boolean
}

const InputText: ForwardRefRenderFunction<'input', InputTextProps> = (
  { type, InputProps, InputLabelProps, success, ...args },
  ref,
) => {
  const classes = useStyles()
  const [showPassword, setShowPassword] = useState(false)

  const renderEndAdornment = (defaultIcon?: React.ReactNode) =>
    type === 'password' ? (
      <IconButton edge={'end'} onClick={() => setShowPassword(!showPassword)}>
        {showPassword ? (
          <VisibilityOff color='secondary' />
        ) : (
          <Visibility color='secondary' />
        )}
      </IconButton>
    ) : (
      defaultIcon
    )

  return (
    <TextField
      className={classes.main}
      variant='outlined'
      {...args}
      type={showPassword ? 'text' : type}
      inputRef={ref}
      InputLabelProps={{
        ...InputLabelProps,
        classes: {
          root: cls(classes.inputLabelRoot, {
            success,
          }),
          ...InputLabelProps?.classes,
        },
      }}
      InputProps={{
        ...InputProps,
        classes: {
          root: cls(classes.inputRoot, {
            success,
          }),
          ...InputProps?.classes,
        },
        endAdornment: renderEndAdornment(InputProps?.endAdornment),
      }}
      FormHelperTextProps={{
        classes: { root: cls(success && classes.helpTextSuccess) },
      }}
    />
  )
}
export default forwardRef(InputText)
